










import Vue from 'vue'
export default Vue.extend({
    name: 'Start',
    data() {
        return {
            url: '',
            file: null
        };
    },
    methods: {
        loadUrl: function() {
            this.$emit('load-url', this.url)
        },
        loadFile: function(value: any) {
            this.$emit('load-file', value);
        }
    }
})
